import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/logo.png';
import _imports_1 from '@/assets/images/svg/history.svg';

const _withScopeId = n => (_pushScopeId("data-v-80b6f94a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  id: "home",
  class: "home"
};
const _hoisted_2 = {
  key: 0,
  class: "download"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("p", null, "棒棒视频APP"), /*#__PURE__*/_createElementVNode("p", null, "更好的观影体验")])], -1));

const _hoisted_4 = {
  class: "btn"
};
const _hoisted_5 = {
  class: "header"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "everyday"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo",
  alt: "",
  srcset: ""
})], -1));

const _hoisted_7 = {
  class: "search"
};
const _hoisted_8 = {
  class: "publishIcon"
};
const _hoisted_9 = {
  class: "tab_box webkit-overflow-scrolling-touch"
};
const _hoisted_10 = {
  class: "details_page"
};
const _hoisted_11 = {
  class: "details_page"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_van_search = _resolveComponent("van-search");

  const _component_focus_component = _resolveComponent("focus-component");

  const _component_Featured = _resolveComponent("Featured");

  const _component_todays_headlines = _resolveComponent("todays-headlines");

  const _component_latest_component = _resolveComponent("latest-component");

  const _component_AdultComics = _resolveComponent("AdultComics");

  const _component_VideoList = _resolveComponent("VideoList");

  const _component_van_tab = _resolveComponent("van-tab");

  const _component_van_tabs = _resolveComponent("van-tabs");

  const _component_van_popup = _resolveComponent("van-popup");

  const _component_HistoryComponent = _resolveComponent("HistoryComponent");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [$setup.showDown ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("span", {
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.downloadApp && $setup.downloadApp(...args))
  }, "下载APP"), _createElementVNode("div", {
    class: "close",
    onClick: _cache[1] || (_cache[1] = $event => $setup.showDown = false)
  }, [_createVNode(_component_van_icon, {
    size: "25",
    name: "close"
  })])])])) : _createCommentVNode("", true), _createElementVNode("ul", _hoisted_5, [_hoisted_6, _createElementVNode("li", _hoisted_7, [_createVNode(_component_van_search, {
    background: "transparent",
    shape: "round",
    disabled: "",
    placeholder: "视频｜创作",
    onClick: _cache[2] || (_cache[2] = $event => $setup.handleShowStack('VideoSearch'))
  })]), _createElementVNode("li", _hoisted_8, [_createElementVNode("img", {
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.toHistory && $setup.toHistory(...args)),
    src: _imports_1,
    alt: ""
  })])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_van_tabs, {
    active: $setup.active,
    "onUpdate:active": _cache[4] || (_cache[4] = $event => $setup.active = $event),
    swipeable: "",
    animated: "",
    "swipe-threshold": 6,
    background: "#276AD3",
    "title-active-color": "#ffffff",
    "title-inactive-color": "#ffffff",
    "line-height": "3px"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.navs, item => {
      return _openBlock(), _createBlock(_component_van_tab, {
        "title-class": "nav_title",
        title: item.name,
        key: item.id
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "cont_body",
          style: _normalizeStyle({
            height: $setup.showBottomBanner ? 'calc(100vh - 220px)' : 'calc(100vh - 150px)'
          })
        }, [item.id === 'gz' ? (_openBlock(), _createBlock(_component_focus_component, {
          key: 0
        })) : item.id === 'jx' ? (_openBlock(), _createBlock(_component_Featured, {
          key: 1
        })) : item.id === 'rm' ? (_openBlock(), _createBlock(_component_todays_headlines, {
          key: 2
        })) : item.id === 'zx' ? (_openBlock(), _createBlock(_component_latest_component, {
          key: 3
        })) : item.id === 'mh' ? (_openBlock(), _createBlock(_component_AdultComics, {
          key: 4
        })) : (_openBlock(), _createBlock(_component_VideoList, {
          id: item.id,
          key: item.id
        }, null, 8, ["id"]))], 4)]),
        _: 2
      }, 1032, ["title"]);
    }), 128))]),
    _: 1
  }, 8, ["active"])]), _createVNode(_component_van_popup, {
    show: $setup.showAdultComicsPopul,
    "onUpdate:show": _cache[5] || (_cache[5] = $event => $setup.showAdultComicsPopul = $event),
    class: "popup_coentent",
    overlay: false,
    position: "right"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createVNode(_component_AdultComics, {
      onClose: $setup.close
    }, null, 8, ["onClose"])])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showHistoryPopul,
    "onUpdate:show": _cache[6] || (_cache[6] = $event => $setup.showHistoryPopul = $event),
    class: "popup_coentent",
    overlay: false,
    position: "right"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [(_openBlock(), _createBlock(_component_HistoryComponent, {
      key: $setup.key,
      onClose: $setup.close1
    }, null, 8, ["onClose"]))])]),
    _: 1
  }, 8, ["show"])]);
}